var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21C24.866 17.134 24.866 10.866 21 7.00001C17.134 3.13401 10.866 3.13401 7 7C3.13401 10.866 3.13401 17.134 7 21C10.866 24.866 17.134 24.866 21 21Z",
    fill: "#FFD05D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1812 5.55273C20.167 7.09186 20.7387 8.9217 20.7387 10.8851C20.7387 16.3525 16.3065 20.7847 10.8391 20.7847C8.94025 20.7847 7.16651 20.2496 5.65967 19.3228C7.41901 22.0695 10.4978 23.89 14.0018 23.89C19.4692 23.89 23.9014 19.4579 23.9014 13.9904C23.9015 10.4219 22.013 7.29477 19.1812 5.55273Z",
    fill: "#FDC453"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44629 15.047C5.44629 9.97088 9.56136 5.85581 14.6375 5.85581C17.6046 5.85581 20.2428 7.26219 21.9233 9.44417C20.3362 6.6889 17.3614 4.83398 13.9534 4.83398C8.87728 4.83398 4.76221 8.94905 4.76221 14.0252C4.76221 16.1343 5.47312 18.077 6.66765 19.6281C5.89077 18.2794 5.44629 16.7152 5.44629 15.047Z",
    fill: "#FFD77F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94435 15.4903C9.68941 15.2425 9.2807 15.5165 9.41288 15.8466C10.1443 17.6742 11.9311 18.9654 14.02 18.9654C16.0742 18.9654 17.8359 17.7171 18.5896 15.9378C18.7271 15.6131 18.3153 15.3322 18.0622 15.5776C16.6133 16.9821 13.5376 18.9809 9.94435 15.4903Z",
    fill: "#5E4939"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0847 12.2275C11.0847 12.9065 10.7581 13.457 10.3554 13.457C9.95257 13.457 9.62598 12.9065 9.62598 12.2275C9.62598 11.5484 9.95257 10.998 10.3554 10.998C10.7581 10.998 11.0847 11.5484 11.0847 12.2275Z",
    fill: "#303030"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3788 12.2275C18.3788 12.9065 18.0522 13.457 17.6494 13.457C17.2466 13.457 16.9199 12.9065 16.9199 12.2275C16.9199 11.5484 17.2465 10.998 17.6494 10.998C18.0523 10.998 18.3788 11.5484 18.3788 12.2275Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji3);
export default __webpack_public_path__ + "static/media/Emoji3.0185714e6e695e47ac6caba476c574b4.svg";
export { ForwardRef as ReactComponent };